(() => {
  function gallery(root) {
    if (root.nikkiProductCleanup) return;
    const media = root.querySelector('[data-nikki-gallery]');
    const info = root.querySelector('.product__info-container');
    if (!media || !info) return;
    const listeners = new AbortController();
    const thumbnails = media.querySelector('[id^="Slider-Thumbnails"]');
    const more = media.querySelector('[data-nikki-gallery-more]');
    const status = media.querySelector('[data-nikki-gallery-status]');
    const initialCount = 12;
    let expanded = false;
    function thumbnailItems() {
      return thumbnails ? [...thumbnails.querySelectorAll('[data-target]')].filter(item =>
        !item.classList.contains('thumbnail-list_item--variant') || item === thumbnails.firstElementChild
      ) : [];
    }
    function refreshThumbnails() {
      if (!thumbnails || !more) return;
      const items = thumbnailItems();
      // A variant may select media outside the first three rows.
      if (items.findIndex(item => item.querySelector('[aria-current="true"]')) >= initialCount) expanded = true;
      thumbnails.querySelectorAll('[data-target]').forEach(item => { item.hidden = false; });
      items.forEach((item, index) => { item.hidden = !expanded && index >= initialCount; });
      const remaining = Math.max(0, items.length - initialCount);
      more.hidden = expanded || remaining === 0;
      more.setAttribute('aria-expanded', String(expanded));
      more.querySelector('[data-nikki-gallery-remaining]').textContent = `(+${remaining})`;
    }
    more?.addEventListener('click', () => {
      const firstNew = thumbnailItems()[initialCount];
      expanded = true;
      refreshThumbnails();
      if (status) status.textContent = `Showing all ${thumbnailItems().length} product images and media.`;
      // Move focus from the now-hidden control to the newly available photos.
      firstNew?.querySelector('button')?.focus({ preventScroll: true });
    }, { signal: listeners.signal });
    const thumbnailChanges = new MutationObserver(refreshThumbnails);
    if (thumbnails) thumbnailChanges.observe(thumbnails, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-current', 'class'] });
    refreshThumbnails();
    let frame = 0;
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(size); };
    function size() {
      if (!root.isConnected) return;
      if (!matchMedia('(min-width: 750px)').matches) { media.style.removeProperty('--nikki-stage-height'); return; }
      const buttons = [...info.querySelectorAll('shopify-accelerated-checkout, .shopify-payment-button__button, .product-form__submit')];
      const payment = buttons.find(el => el.matches('shopify-accelerated-checkout') && el.getBoundingClientRect().height > 10)
        || buttons.find(el => el.matches('.shopify-payment-button__button') && el.getBoundingClientRect().height > 10)
        || buttons.find(el => el.getBoundingClientRect().height > 10);
      if (!payment) { media.style.removeProperty('--nikki-stage-height'); return; }
      // Align the main image with purchasing controls; the grid grows below it.
      // Revealing more thumbnails must never shrink the selected product photo.
      const target = payment.getBoundingClientRect().bottom - media.getBoundingClientRect().top;
      const height = Math.max(240, Math.round(target));
      if (media.style.getPropertyValue('--nikki-stage-height') !== `${height}px`) media.style.setProperty('--nikki-stage-height', `${height}px`);
    }
    const resize = new ResizeObserver(schedule);
    resize.observe(info); resize.observe(root);
    const mutation = new MutationObserver(schedule);
    mutation.observe(info, { childList: true, subtree: true, attributes: true });
    window.addEventListener('resize', schedule, { signal: listeners.signal });
    root.addEventListener('load', schedule, { capture: true, signal: listeners.signal });
    document.fonts?.ready.then(schedule);
    root.nikkiProductCleanup = () => { listeners.abort(); resize.disconnect(); mutation.disconnect(); thumbnailChanges.disconnect(); cancelAnimationFrame(frame); };
    schedule();
  }
  function share(root) {
    if (root.nikkiProductCleanup) return;
    const listeners = new AbortController(), signal = listeners.signal;
    const status = root.querySelector('[data-share-status]');
    const fallback = root.querySelector('[data-share-fallback]');
    const data = { url: root.dataset.shareUrl, title: root.dataset.shareTitle, text: root.dataset.shareText };
    const manual = () => { fallback.hidden = false; const input = fallback.querySelector('input'); input.focus(); input.select(); status.textContent = 'Select and copy the product link below.'; };
    async function copy() {
      try { await navigator.clipboard.writeText(data.url); status.textContent = 'Product link copied.'; fallback.hidden = true; }
      catch (_) { manual(); }
    }
    const copyButton = root.querySelector('[data-share-copy]'); copyButton.hidden = false;
    copyButton.addEventListener('click', copy, { signal });
    const native = root.querySelector('[data-share-native]'); native.hidden = false;
    native.addEventListener('click', async () => {
      if (!navigator.share) { await copy(); return; }
      try { await navigator.share(data); status.textContent = 'Product shared.'; }
      catch (e) { if (e.name !== 'AbortError') manual(); }
    }, { signal });
    root.nikkiProductCleanup = () => listeners.abort();
  }
  const components = [['[data-nikki-product-layout]', gallery], ['[data-nikki-share]', share]];
  function init(scope) { components.forEach(([selector, fn]) => { if (scope.matches?.(selector)) fn(scope); scope.querySelectorAll(selector).forEach(fn); }); }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => { components.forEach(([selector]) => e.target.querySelectorAll(selector).forEach(node => { node.nikkiProductCleanup?.(); delete node.nikkiProductCleanup; })); });
})();
